import { render, staticRenderFns } from "./AdvisorySteps.vue?vue&type=template&id=29853ab6&scoped=true"
import script from "./AdvisorySteps.vue?vue&type=script&lang=js"
export * from "./AdvisorySteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29853ab6",
  null
  
)

export default component.exports